import { lbPropositionApi } from '@/utils/axiosConfig';

/**
 * Fetch a summary of recent visitors for a proposition.
 * Returns `{ count, latest }` where `count` is the total number of
 * recent visitors and `latest` is a small array of residence image
 * URLs for the avatar stack.
 *
 * On any error returns `{ count: 0, latest: [] }` — callers should
 * treat the absence of visitors as "hide the visitor UI" rather
 * than as an error to surface.
 */
export async function fetchRecentVisitors(propositionId) {
  if (!propositionId) return { count: 0, latest: [] };

  try {
    const { data } = await lbPropositionApi.get(
      `/views/v2/${propositionId}/summary`
    );
    return {
      count: Number.isFinite(data?.count) ? data.count : 0,
      latest: Array.isArray(data?.latest) ? data.latest : []
    };
  } catch (e) {
    return { count: 0, latest: [] };
  }
}

/**
 * Pick the first N visitor avatar image URLs from a summary — useful
 * for the avatar stack on visitor cards/footers.
 *
 * Visitors whose own listing has no photo come back as null/"" in
 * `latest`; those are skipped so the stack never shows an empty circle.
 */
export function getVisitorAvatars(summary, max = 3) {
  return ((summary && summary.latest) || [])
    .filter(url => typeof url === 'string' && url.trim() !== '')
    .slice(0, max);
}
